import { useMemo } from 'react';

import { Drawer } from '@mui/material';

import CancelablePopup from '@/components/CancelablePopup';
import presets from '@/components/CancelablePopup/presets';
import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import { AppSelector } from '@/features/Dashboard/drawer/steps/AppSelector';
import { ImportMarketWidget } from '@/features/Dashboard/drawer/steps/ImportMarketWidget';
import { AppForm } from '@/features/Dashboard/form/AppForm';

export const DashboardDrawer = () => {
  const { drawerStep, confirmOpen, handleAttemptClose, handleConfirmClose, handleCancelClose } =
    useDrawerSteps();

  const content = useMemo(() => {
    switch (drawerStep) {
      case DrawerStep.SelectApp:
        return <AppSelector />;
      case DrawerStep.SelectMarketWidget:
        return <ImportMarketWidget />;
      default:
        return <AppForm />;
    }
  }, [drawerStep]);

  return (
    <>
      <Drawer
        anchor='right'
        ModalProps={{
          keepMounted: true,
          // Prevent closing on backdrop click and Escape key, we'll handle it manually
          disableEscapeKeyDown: true
        }}
        open={Boolean(drawerStep)}
        slotProps={{
          paper: {
            sx: theme => ({
              width: { xs: '100%', sm: 678 },
              maxWidth: '100%',
              boxSizing: 'border-box',
              marginLeft: 'auto',
              backgroundColor: theme.palette.background.default
            })
          },
          backdrop: {
            sx: {
              backgroundColor: 'rgba(18, 22, 63, 0.80)',
              backdropFilter: 'blur(1px)'
            },
            // Block default backdrop click close; we'll route it to onClose where we can decide
            onClick: handleAttemptClose
          }
        }}
        variant='temporary'
        onClose={handleAttemptClose}
      >
        {content}
      </Drawer>
      <CancelablePopup
        isOpened={confirmOpen}
        setIsOpened={handleCancelClose}
        onConfirm={handleConfirmClose}
        {...presets.discard}
      />
    </>
  );
};
